import { Skeleton } from '@skin-seoul/design-system';

export function CartRewardUpsellSkeleton() {
  return (
    <section
      role="status"
      aria-label="Loading reward offers"
      aria-busy="true"
      className="-mx-4 -mb-3 mt-1 overflow-hidden bg-white"
    >
      <div aria-hidden="true" className="flex gap-2.5 px-4 py-3">
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            className="flex h-[94px] w-[276px] shrink-0 items-center gap-1.5 rounded-xl bg-white px-2.5 py-2 shadow-[0_2px_7px_rgba(0,0,0,0.1)]"
          >
            <Skeleton className="size-[62px] shrink-0 rounded-lg motion-reduce:animate-none" />
            <div className="flex w-[150px] shrink-0 flex-col gap-1.5">
              <Skeleton className="h-3 w-16 motion-reduce:animate-none" />
              <Skeleton className="h-4 w-full motion-reduce:animate-none" />
              <div className="flex items-center gap-1">
                <Skeleton className="h-4 w-14 motion-reduce:animate-none" />
                <Skeleton className="h-3 w-11 motion-reduce:animate-none" />
              </div>
            </div>
            <Skeleton className="size-7 shrink-0 rounded-full motion-reduce:animate-none" />
          </div>
        ))}
      </div>
    </section>
  );
}
